export default __webpack_public_path__ + "static/media/rectangle@2x.2274cc2c.png";